import React, { useEffect, useState } from 'react'
import { Button, Image, Label } from 'semantic-ui-react'
import './Modality.scss'
import arrow from '../../assets/arrow.svg'
import fbConfig from '../../config/fbConfig'
import arrow_privacy from '../../assets/arrow-privacy.svg'
import ilus_inicio from '../../assets/ilus-inicio.svg'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { getDataPreferencesFromUser } from '../../redux/actions/user'

const Modality = props => {

    const { result, authError } = props;
    const [isPrivacy, setIsPrivacy] = useState(false)

    useEffect(() => {

        fbConfig.auth().onAuthStateChanged(user => {
            if(user) {

                props.getDataPreferencesFromUser()

                if(result && !authError) {
                    props.history.push('/')
                }
            
            } else {
                props.history.push('/signin')
            }
        });
        
    }, [result, authError])

    // Vamos a elegir nuestras preferencias
    const goPreferences = () => {
        props.history.push('/choose/preferences')
    }

    return (
        <div className='modality' style={{ backgroundColor: isPrivacy === true ? '#004d80' : '#FFF' }}>
            <div className='modality_left'>
                <Label style={{ color: isPrivacy === true ? '#FFF' : '#333333'}}>Te devolvemos 
                    <b style={{ marginLeft: '5px', color: isPrivacy === true ? '#FFF' : '#055c9d' }}>
                        el poder
                    </b>
                </Label>
                <span style={{ color: isPrivacy === true ? '#FFF' : '#333333'}}>Escoge tu modalidad</span>

                <div className='modality_left_actions'>
                    <Button 
                        className={ isPrivacy ? 'btn_white' : 'btn_blue'} 
                        onClick={() => setIsPrivacy(false)}
                        >
                        Recompensas
                    </Button>
                    <Button 
                        className={ isPrivacy ? 'btn_blue' : 'btn_white'} 
                        onClick={() => setIsPrivacy(true)}
                        >
                        Privacidad
                    </Button>
                </div>

                <div className='modality_left_text'>
                    { isPrivacy === false ? <p style={{ color: isPrivacy === true ? '#FFF' : '#333333'}}>
                        Esta funcionalidad le permitirá recibir un ingreso pasivo a partir de sus datos personales. 
                        Hoy en día, los datos tienen un valor inmenso y Shield le permite quedarse con estas ganancias.
                    </p> :
                    <p style={{ color: isPrivacy === true ? '#FFF' : '#333333'}}>
                    Los navegadores de hoy en día están repletos de rastreadores que no necesita y que muchas veces no están autorizados. 
                    Recupere el control de su información con Shield en solamente unos clicks! 
                    La extension de Shield le permite escoger qué tipo de información las empresas pueden extraer de usted.
                    </p>}
                </div>

                {
                    isPrivacy ?
                    <Image src={arrow_privacy} onClick={goPreferences} /> :
                    <Image src={arrow} onClick={goPreferences} />
                }

                <span style={{ color: isPrivacy === true ? '#FFF' : '#333333'}}>
                    <b style={{ color: isPrivacy === true ? '#FFF' : '#333333'}}>Doy mi consentimiento</b> para habilitar el modo recompensas
                </span>
            </div>
            <div className='modality_right'>
                <Image src={ilus_inicio} />
            </div>
        </div>
    )
}

const mapStateToProps = state => {

    // Comprobamos si el usuario ya tiene registradas sus preferencias
    const result = state.user.result
    const authError = state.user.authError

    return {
        result,
        authError
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getDataPreferencesFromUser: () => dispatch(getDataPreferencesFromUser()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Modality))